import { render, staticRenderFns } from "./FormMixin.vue?vue&type=template&id=1523dd22&scoped=true&"
import script from "./FormMixin.vue?vue&type=script&lang=js&"
export * from "./FormMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1523dd22",
  null
  
)

export default component.exports